import axios from "./axiosInstance";

const academicsAPI ={ 
   academics_listing: () => axios.get("academics"),
    
}

export default academicsAPI;